import Lottie from 'lottie-react';
import successLottie from '@/assets/lottie/success.json';
import { Box, Center } from '@mantine/core';
import classes from './success.module.css';

const SuccessAgreeTerms = () => (
  <Box>
    <div className={classes.root}>
      <div className={classes.card}>
        <div className={classes.animationWrap} aria-hidden="true">
          <Lottie
            animationData={successLottie}
            loop={false}
            className={classes.animation}
          />
        </div>

        <Center className={classes.texts}>
          <div>
            <h1 className={classes.title}>תודה רבה!</h1>
            <p className={classes.subtitle}>
              הסכמת לתנאי השימוש בהצלחה. אפשר להמשיך לשלב הבא.
            </p>
          </div>
        </Center>
      </div>
    </div>
  </Box>
);

export default SuccessAgreeTerms;
